import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { MapPin, LogOut } from "lucide-react";
import logo from "../images/booking_logo.png";
import "./BookingHeader.css";

export default function BookingHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav className="booking-navbar">
      <div className="booking-nav-inner">
        {/* LEFT: Logo */}
        <div className="booking-nav-logo" onClick={() => navigate("/")}>
          <img src={logo} alt="Calyx Logo" />
        </div>

        {/* CENTER: NAV LINKS (Optional) */}
        <div className="booking-nav-links">
           {/* Add nav links here if needed to match homepage */}
        </div>

        {/* CENTER: Location */}
        <div className="booking-nav-location">
          <MapPin size={18} className="location-pin" />
          <span>Mumbai</span>
        </div>

        {/* RIGHT: Auth */}
        <div className="booking-nav-right">
          {!user ? (
            <Link to="/login" className="booking-login-btn">Login</Link>
          ) : (
            <div className="booking-user-box">
              <span>{user.name}</span>
              <button onClick={handleLogout} className="booking-logout-btn">
                <LogOut size={16} />
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
